<template>
  <div class="chem-card">
    <div class="flex item-name-area">
      <q-checkbox v-model="resultDetailCheckbox" color="primary" :val="props.result.atto_id">
        <div class="product-name flex items-center">
          <p class="q-mb-none">{{ props.result.atto_id }}</p>
        </div>
      </q-checkbox>
    </div>
    <div class="img-container emphable-img">
      <AtomImage :exatoms="props.result.structure" />
    </div>
    <div class="supplier-bottoms-area flex items-end justify-between mt-1">
      <!-- 検索結果詳細表示ボタン -->
      <q-btn color="primary" @click="onDetail(props.result.atto_id)">詳細</q-btn>

      <div class="supplier-num-area flex items-end justify-between">
        <div v-if="props.result.order_count === 0" class="tag-area w-100 text-right">
          <p class="q-mb-none">要問合せ</p>
        </div>
        <p class="supplier-label q-mb-non">取扱い数</p>
        <p
          :class="
            'q-mb-none supplier-number ' +
            (props.result.atto_supplier_count === 0 ? 'supplier-none' : '')
          "
        >
          {{ props.result.atto_supplier_count }}
        </p>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import AtomImage from '../images/AtomImage.vue';

// 検索結果interface
interface Result {
  atto_id: string;
  atto_supplier_count: number;
  order_count: number;
  condition_id: number;
  result_id: number;
  result_number: number;
  structure: string;
}

interface Props {
  // 検索結果
  result: Result;
  // チェック値
  checkValues: Array<string>;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  (event: 'changeCheck', attoIdList: Array<string>): void;
  (event: 'onDetail', attoId: string): void;
}>();

// チェックボックス
const resultDetailCheckbox = computed({
  get: () => props.checkValues,
  set: (value) => {
    emit('changeCheck', value);
  },
});

// 詳細ボタン押下
const onDetail = (attoId: string) => {
  emit('onDetail', attoId);
};
</script>

<style scoped>
p {
  margin: 0;
  padding: 0;
}

.chem-card .img-container {
  height: 160px;
  display: flex;
}

.chem-card .product-name p {
  letter-spacing: 1px;
  color: var(--q-plainBlack);
  font-weight: bold;
  line-height: 1.1rem;
  font-size: 1.1rem;
  padding-top: 2px;
}

.chem-card .img-container .q-img {
  width: 80%;
}

.chem-card .q-btn {
  width: 90px;
  padding: 5px 0;
  font-size: 1.1rem;
  line-height: 1.1rem;
  padding-left: 2px;
  letter-spacing: 2px;
  min-height: 40px;
}

.chem-card .supplier-bottoms-area {
  margin-top: 12px;
  padding-left: 10px;
  padding-right: 6px;
}

.supplier-num-area {
  width: calc(100% - 100px);
  position: relative;
}

.supplier-num-area .tag-area {
  position: absolute;
  right: -0;
  top: -30px;
  display: flex;
  justify-content: flex-end;
}

.supplier-num-area .tag-area p {
  width: 116px;
  border-radius: 4px;
  background-color: rgb(187, 219, 175, 0.7);
  padding: 2px 4px;
  text-align: center;
}

.supplier-number {
  font-size: 1.2rem;
  line-height: 1.2rem;
  font-weight: 600;
  letter-spacing: 2px;
  padding-left: 4px;
  color: var(--q-primary);
}

@media screen and (min-width: 1440px) {
  .chem-card .img-container {
    height: 180px;
  }
}

@media screen and (min-width: 1680px) {
  .chem-card .img-container {
    height: 200px;
  }

  .chem-card .supplier-bottoms-area {
    padding-left: 10px;
    padding-right: 10px;
  }

  .chem-card .q-btn {
    width: 100px;
  }

  .supplier-num-area {
    width: calc(100% - 120px);
  }
}
</style>
